<template>
  <div class="flex justify-center">
    <div class="sk-header absolute top-0 left-0 flex justify-end items-center">
      <div class="w-64">
        <div class="justify-between flex">
          <div class="flex flex-col justify-center items-end pr-2">
            <span class="sk-line h-4 mb-2 w-40"/>
            <span class="sk-line h-4 w-2/3"/>
          </div>
          <span class="sk-header-avatar relative rounded-full overflow-hidden" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "bgSkeletonSSO"
}
</script>

<style lang="scss" scoped>
.sk-header {
  width: 100%;
  height: 4.469rem;
  margin: 0 0.006rem 0 0;
  padding: 0 3.722rem 0 0;
  box-shadow: 0 4px 4px 0 rgba(150, 150, 150, 0.1);
  background-color: #ffffff;
}
.sk-header-avatar {
  background-color: #c4c4c4;
  width: 50px;
  height: 50px;
}
.sk-header-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-tiny-avatar {
  background-color: #c4c4c4;
  width: 32px;
  height: 32px;
}
.sk-tiny-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-info-avatar {
  background-color: #c4c4c4;
  width: 80px;
  height: 80px;
}
.sk-info-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-bh-avatar::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line {
  background-color: #c4c4c4;
  overflow: hidden;
  position: relative;
  border-radius: 10px;
}
.sk-line::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.sk-line-alter {
  background-color: #dedede;
  overflow: hidden;
  position: relative;
}
.sk-line-alter::before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 150px;
  background: linear-gradient(
          to right,
          transparent 0%,
          #e8e8e8 50%,
          transparent 100%
  );
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}
.height-box-main {
  height: 24.18rem;
}
@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
</style>
